import axios from "axios";

export const state = {
    feescategories: [],
};

export const getters = {
    feescategories: state => state.feescategories,
};

export const mutations = {
    setFeesCategories(state, newValue) {
        state.feescategories = newValue
    },
};

export const actions = {
    fetchFeesCategories({ commit }) {
        axios.get('/feescategories').then(res => {
            commit('setFeesCategories', res.data.feescategories);
        })
    },
};
